/**
 * Admin reports API endpoints.
 */

import { http } from './http';
import type { PaginatedResponse, Report, ReportFilters } from './types';

/** GET /api/v1/admin/reports */
export async function listReports(filters?: ReportFilters): Promise<PaginatedResponse<Report>> {
  const params = new URLSearchParams();
  if (filters?.search) params.set('search', filters.search);
  if (filters?.status) params.set('status', filters.status);
  if (filters?.user_id) params.set('user_id', filters.user_id);
  if (filters?.cursor) params.set('cursor', filters.cursor);
  if (filters?.limit) params.set('limit', String(filters.limit));
  if (filters?.created_after) params.set('created_after', filters.created_after);
  if (filters?.created_before) params.set('created_before', filters.created_before);

  const query = params.toString();
  return http.get(`/admin/reports${query ? `?${query}` : ''}`);
}

/** GET /api/v1/admin/reports/:id */
export async function getReport(id: string): Promise<{ report: Report }> {
  return http.get(`/admin/reports/${id}`);
}

/** PATCH /api/v1/admin/reports/:id */
export async function updateReport(
  id: string,
  data: { status?: string },
): Promise<{ report: Report }> {
  return http.patch(`/admin/reports/${id}`, data);
}

/** DELETE /api/v1/admin/reports/:id */
export async function deleteReport(id: string): Promise<void> {
  await http.delete(`/admin/reports/${id}`);
}
